import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { beginNavigation, hasTrackingContext, queuePageVisit } from "../utils/apiAttribution";
import { trackMetaPageView } from "../utils/metaPixel";
import { api } from "../services/api";


const MarketingPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    const navigationId = beginNavigation(location.key);
    const url = window.location.href;
    queuePageVisit(url, navigationId);
    trackMetaPageView(navigationId);

    if (hasTrackingContext()) {
      void api.recordPageView(url, navigationId).catch(() => {});
    }
  }, [location.key, location.pathname, location.search]);

  return null;
};

export default MarketingPageViews;
